import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../auth/AuthProvider";
import { useOrganization } from "../auth/OrganizationProvider";
import { scopedQueryKey } from "../lib/query-scope";
import { platformRepository } from "../repositories/platform";

function useScopedPlatformQuery<T>(key: string, queryFn: () => Promise<T>) {
  const { user } = useAuth();
  const { activeOrganizationId } = useOrganization();
  return useQuery({
    queryKey: scopedQueryKey({ userId: user?.id ?? null, organizationId: activeOrganizationId }, [
      key,
    ]),
    queryFn,
    enabled: Boolean(user && activeOrganizationId),
  });
}

export const useDashboardData = () =>
  useScopedPlatformQuery("dashboard", () => platformRepository.dashboard());
export const useCustomersData = () =>
  useScopedPlatformQuery("customers", () => platformRepository.customers());
export const useSalesData = () => useScopedPlatformQuery("sales", () => platformRepository.sales());
export const useContractsData = () =>
  useScopedPlatformQuery("contracts", () => platformRepository.contracts());
export const useInvoicesData = () =>
  useScopedPlatformQuery("invoices", () => platformRepository.invoices());
export const useCommissionsData = () =>
  useScopedPlatformQuery("commissions", () => platformRepository.commissions());
export const useTelemedicineData = () =>
  useScopedPlatformQuery("telemedicine", () => platformRepository.telemedicine());
export const useIntegrationsData = () =>
  useScopedPlatformQuery("integrations", () => platformRepository.integrations());
export const useTeamData = () => useScopedPlatformQuery("team", () => platformRepository.team());
